import { render, staticRenderFns } from "./Studygroup.vue?vue&type=template&id=5bc5c8ec&scoped=true&"
import script from "./Studygroup.vue?vue&type=script&lang=js&"
export * from "./Studygroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc5c8ec",
  null
  
)

export default component.exports